(function () {
  if (window.__drawerCustomShippingOverrideLoaded) return;
  window.__drawerCustomShippingOverrideLoaded = true;

  function getCustomBars() {
    return document.querySelectorAll('shipping-bar[data-drawer-custom-shipping-bar]');
  }

  function formatDrawerMoney(cents, moneyFormat) {
    if (typeof window.formatPrice === 'function') {
      return window.formatPrice(moneyFormat, cents / 100);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (Number(cents || 0) / 100).toFixed(2);
  }

  function buildMessage(template, formattedAmount) {
    if (!template) return formattedAmount;

    const moneyMatch = template.match(/<span class="money">(.*)<\/span>/);
    if (moneyMatch) {
      return template.replace(moneyMatch[1], formattedAmount);
    }

    return String(template).replace(/\[amount\]|\{amount\}/g, formattedAmount);
  }

  function renderCustomBars(cart) {
    const bars = getCustomBars();
    if (!bars.length || !cart) return;

    const conversionRate =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate
        ? Number(window.Shopify.currency.rate)
        : 1;

    bars.forEach((bar) => {
      const textEl = bar.querySelector('.progress-bar__text');
      const progressEl = bar.querySelector('[data-progress-line]');
      const baseThreshold = Number(bar.dataset.shippingThreshold || 0);
      const threshold = Math.round(baseThreshold * conversionRate);
      const totalPrice = Number(cart.total_price || 0);
      const itemCount = Number(cart.item_count || 0);
      const remainingAmount = Math.max(threshold - totalPrice, 0);

      const messageTemplate = bar.dataset.messageTemplate || 'You are [amount] away from free shipping';
      const successTemplate = bar.dataset.successTemplate || 'You’ve unlocked free shipping';
      const moneyFormat =
        bar.dataset.moneyFormat ||
        (window.theme && window.theme.settings && window.theme.settings.money_format) ||
        '${{amount}}';

      bar.style.visibility = itemCount === 0 ? 'hidden' : 'visible';

      if (!threshold) {
        if (progressEl) progressEl.style.width = '0%';
        return;
      }

      if (textEl) {
        if (totalPrice >= threshold) {
          textEl.innerHTML = successTemplate;
        } else {
          const formattedAmount = formatDrawerMoney(remainingAmount, moneyFormat);
          textEl.innerHTML = buildMessage(messageTemplate, formattedAmount);
        }
      }

      if (progressEl) {
        if (totalPrice >= threshold) {
          progressEl.style.width = '100%';
        } else {
          progressEl.style.width = `calc(${(totalPrice / threshold) * 100}% + 2px)`;
        }
      }
    });
  }

  async function updateCustomDrawerShipping(cartState) {
    let cart = cartState;

    if (!cart || typeof cart.total_price === 'undefined') {
      const response = await fetch('/cart.js');
      cart = await response.json();
    }

    renderCustomBars(cart);
  }

  function patchCartDrawerRender() {
    const CartDrawerClass = customElements.get('cart-drawer');
    if (!CartDrawerClass || CartDrawerClass.prototype.__drawerCustomShippingPatched) return;

    const originalRenderContents = CartDrawerClass.prototype.renderContents;
    if (typeof originalRenderContents !== 'function') return;

    CartDrawerClass.prototype.renderContents = function () {
      const result = originalRenderContents.apply(this, arguments);
      const response = arguments[0];

      setTimeout(() => {
        window.updateFreeShipping(response);
      }, 0);

      return result;
    };

    CartDrawerClass.prototype.__drawerCustomShippingPatched = true;
  }

  function boot() {
    const originalUpdateFreeShipping =
      typeof window.updateFreeShipping === 'function'
        ? window.updateFreeShipping.bind(window)
        : null;

    if (!window.__drawerCustomShippingWrapped) {
      window.__drawerCustomShippingWrapped = true;

      window.updateFreeShipping = async function () {
        const args = arguments;
        const cartState = args[0];

        if (originalUpdateFreeShipping) {
          try {
            await originalUpdateFreeShipping.apply(window, args);
          } catch (error) {
            console.error('Original updateFreeShipping failed:', error);
          }
        }

        try {
          await updateCustomDrawerShipping(cartState);
        } catch (error) {
          console.error('Custom drawer shipping update failed:', error);
        }
      };
    }

    if (customElements.get('cart-drawer')) {
      patchCartDrawerRender();
    } else if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(() => {
        patchCartDrawerRender();
      });
    }

    window.updateFreeShipping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    if (typeof window.updateFreeShipping === 'function') {
      window.updateFreeShipping();
    }
  });

  window.addEventListener('pageshow', function () {
    if (typeof window.updateFreeShipping === 'function') {
      window.updateFreeShipping();
    }
  });
})();